const boxData = [
  {
    id: 1,
    title: "UI/UX 화면 기획서 작성",
    image: "planning.png",
    items: [
      "프로젝트 초기 단계에서 요구사항 분석을 통한 화면 기획서 작성",
      "사용자 흐름과 기능을 명확히 정의하여 화면 설계 문서화",
      "이해관계자와의 요구사항을 반영한 화면 기획서 수정 및 보완",
      "UI/UX 디자인과 개발 단계에서 참조할 수 있는 상세한 기획서 제공",
    ],
  },
  {
    id: 2,
    title: "기획&디자인",
    image: "figma.png",
    items: [
      "요구사항 분석을 통한 UI/UX 디자인 기획 및 시안 제작",
      "Figma 등의 툴을 사용한 와이어프레임 및 프로토타입 제작",
      "웹사이트 및 애플리케이션의 시각적 디자인 및 스타일 가이드 수립",
      "브랜드에 맞춘 디자인 요소 제작 및 적용",
    ],
  },
  {
    id: 3,
    title: "프론트엔드 개발",
    image: "figma.png",
    items: [
      "Figma, Adobe Photoshop, Illustrator를 활용한 화면 설계",
      "사용자 경험과 인터페이스 최적화를 위한 웹 애플리케이션 개발",
      "React, Timeleaf 등을 활용한 동적 웹 페이지 구현 및 유지보수",
      "크로스 브라우저 호환성 작업 수행",
    ],
  },
];
export default function BoxThree(props) {
  let publicUrl = process.env.PUBLIC_URL + "/";
  let imagealt = "image";

  return (
    <div className="max-w-2xl lg:max-w-7xl mx-auto">
      <div className="relative rounded-xl overflow-auto pt-8 pb-8">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-x-12 gap-y-8 p-1 text-white text-sm text-center leading-6 bg-stripes-sky rounded-3xl">
          {boxData.map((item) => (
            <div
              key={item.id}
              className="box w-full mx-auto max-w-2xl items-center gap-y-16 lg:max-w-7xl lg:grid-cols-2 rounded-3xl outline outline-1 outline-gray-100"
            >
              <div className="m-auto items-center justify-center w-full">
                <img
                  src={publicUrl + `assets/images/dpOverview/${item.image}`}
                  alt={imagealt}
                  className="max-w-full max-h-full rounded-t-lg"
                />
              </div>
              <div className="text-left p-4">
                <h2 className="text-xl mb-4 tracking-tight text-white sm:text-xl">
                  {item.title}
                </h2>
                {item.items.map((feat, index) => (
                  <li key={index} className="text-white">
                    {feat}
                  </li>
                ))}
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
